import { AsgmtSubmissionNotificationItem } from './asgmt-submission-notification-item';
import { NotificationItemGroup } from './notification-item-group';

let idx = 0;
export class AssignmentNotificationItemGroup extends NotificationItemGroup {

  studentUidMap: { [studentUid: string]: string } = {};
  sectionNameMap: Map<string, string> = new Map<string, string>(); //TODO Not sure I need this
  notifications: AsgmtSubmissionNotificationItem[];
  sectionString: string;
  groupTooltip: string;

  constructor(public type: string, public aggregationKey: string, public isMarkedReadOnClick, public subtype?: string, public isRead = true, public isSeen = true) {
    super(type, aggregationKey, isMarkedReadOnClick, isRead, isSeen);
    this.id = String(idx++);
  }

  addNotification(notification: AsgmtSubmissionNotificationItem): void {
    super.addNotification(notification);
    if (notification.subtype === AsgmtSubmissionNotificationItem.NOTIFICATION_SUBTYPE) {
      let studentUid: string = notification.getSenderUid() || '';
      let studentName: string = notification.getSubtitle() || '';
      if (this.studentUidMap[studentUid] == null) {
        this.studentUidMap[studentUid] = studentName;
      }
      let studentCount = Object.keys(this.studentUidMap).length - 1;
      let suffix = '';
      if (studentCount === 1) {
        suffix = ` and ${studentCount} other`;
      } else if (studentCount > 1) {
        suffix = ` and ${studentCount} others`;
      }
      this.updateSectionString(notification.getSectionUid(), notification.getSectionName());
      this.subtitle = studentName + suffix;
      this.tooltip = (<any>Object).values(this.studentUidMap).join(', ');
      this.userType = notification.getUserType();
    }
  }

  markAsRead(): void {
    if (this.subtype === AsgmtSubmissionNotificationItem.NOTIFICATION_SUBTYPE) {
      super.markAsRead();
      this.studentUidMap = {};
      this.sectionNameMap = new Map<string, string>();
    }
  }

  getSectionUids(): Array<string> {
    return Array.from(this.sectionNameMap.keys());
  }

  private updateSectionString(sectionUid, sectionName): void {
    if (!this.sectionNameMap.has(sectionUid)) {
      this.sectionNameMap.set(sectionUid, sectionName);
    }

    if (this.sectionNameMap.size === 1) {
      this.sectionString = sectionName;
    } else if (this.sectionNameMap.size > 1) {
      this.sectionString = `${this.sectionNameMap.size} Sections`;
    } else {
      this.sectionString = '';
    }
  }
}
